module.exports = __webpack_public_path__ + "img/SPI-writeonly.c9cae1cd.png";